// TODO: use env variable for api url
export const AppConfig = {
  API_URL:
    process.env.REACT_APP_API_URL || "https://divhubinter.polri.go.id/api",
};
